import { GET_BOOKMARKS, BookmarkState, BookmarkKnownAction, GET_BOOKMARKS_SUCCESS, GET_BOOKMARKS_FAIL } from "./types";
import { Reducer } from "react";



const initialState: BookmarkState = {
    bookmarks: [],
    loading: false,
    error: {
        message: '',
        status: 0
    },
};



const reducer: Reducer<BookmarkState, BookmarkKnownAction> = (
    state: BookmarkState | undefined = initialState,
    action: BookmarkKnownAction,
) => {
    switch (action.type) {
        case GET_BOOKMARKS:
            return {
                ...state,
                loading: true,
            };
        case GET_BOOKMARKS_SUCCESS:
            const filterData = action.payload.filter((bookmark) => {
                if(bookmark.setData.length > 0) {
                    const bookmarkItems = bookmark.setData.filter((item) => {
                        if(item.type === 'file') {
                            //(c: any) => envConfig.invalidCategory.indexOf(c.category) < 0
                            return item.category !== 'app';
                        }
                        if(item.type === 'story') {
                            return item.fileCount > 0 && item.isProtected === false;
                        }
                        return false;
                    });
                    return bookmarkItems.length > 0;
                }
                return false;
            });
            return {
                ...state,
                loading: false,
                bookmarks: filterData,
            };
        case  GET_BOOKMARKS_FAIL:
            return {
                ...state,
                loading: false,
                bookmarks: [],
                error: action.error
            };
        default:
            return state;
    }
};

export default reducer;